export default function Partner() {
  return (
    <div className="bg-neutral-25 flex flex-col lg:gap-8 gap-6 xl:px-[83px] lg:px-12 md:px-8 px-[18px] lg:py-20 py-12 ">
      <div className=" mx-auto font-bold lg:text-3xl text-2xl leading-9 text-brand-primary-850 text-center md:w-fit w-[394px]">Đối tác của KiotViet
        là các ngân hàng uy tín hàng đầu
      </div>
      <div className="flex flex-wrap justify-center xl:gap-[88px] lg:gap-[83px] md:gap-x-[136px] gap-x-[18px] md:gap-y-0 gap-y-6">
        <div className="flex items-center  relative w-[188px] h-20 pt-[11px] pb-[13px] px-[13px]">
          <img src="./images/partners-logo/Vietcombank.png" alt="" className="mx-auto" />
        </div>
        <div className="flex items-center  relative w-[188px] h-20 pt-[27px] pb-[15px] px-[35px]">
          <img src="./images/partners-logo/BIDV.png" alt="" className="mx-auto" />
        </div>
        <div className="flex items-center  relative w-[188px] h-20 pt-[11px] pb-[9px] px-[33px]">
          <img src="./images/partners-logo/VIB.png" alt="" className="mx-auto" />
        </div>
        <div className="flex items-center  relative w-[188px] h-20 pt-[33px] pb-[17px] px-[20px]">
          <img src="./images/partners-logo/MoMo.png" alt="" className="mx-auto" />
        </div>
      </div>
    </div>
  )
}